import * as React from "react";
import Paper from "@mui/material/Paper";
import "./style.css";
import {
  DataGrid,
  GridToolbar,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useSelector } from "react-redux";
import moment from "moment";
import { Helmet } from "react-helmet-async";

const columns = [
  // { field: "id", headerName: "ID", minWidth: 250, align: "left" },
  {
    field: "code",
    headerName: "ASSET CODE",
    minWidth: 170,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    field: "description",
    headerName: "DESCRIPTION",
    minWidth: 170,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    field: "category",
    headerName: "CATEGORY",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    field: "location",
    headerName: "LOCATION",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    field: "cost",
    headerName: "COST",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    field: "sub_location",
    headerName: "SUB-LOCATION",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    field: "purchase_date",
    headerName: "PURCHASE DATE",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    field: "exhaustion_date",
    headerName: "EXHAUSTION DATE",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
  {
    field: "status",
    headerName: "STATUS",
    minWidth: 170,
    align: "left",
    format: (value) => value.toFixed(2),
  },
];

function createData(
  id,
  code,
  description,
  category,
  location,
  cost,
  sub_location,
  purchase_date,
  exhaustion_date
) {
  const status = moment(exhaustion_date) < moment() ? "Exhausted" : "Active";

  return {
    id,
    code,
    description,
    category,
    location,
    cost,
    sub_location,
    purchase_date,
    exhaustion_date,
    status,
  };
}

export default function AssetList() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        color='primary'
        sx={{ bgcolor: "#ffffff" }}
        variant='outlined'
        shape='rounded'
        page={page + 1}
        count={pageCount}
        // @ts-expect-error
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }

  const assetData = useSelector((state) => state.assets);
  const intangibles = useSelector((state) => state.intangible);
  const rightOfUse = useSelector((state) => state.rightOfUse);

  const rows = assetData
    ? [...assetData, ...intangibles, ...rightOfUse]?.map((data) => {
        return createData(
          data.id,
          data.code,
          data.description,
          data.category,
          data.location,
          data.cost,
          data.sub_location,
          moment(data.purchase_date).format("YYYY-MM-DD"),
          moment(data.exhaustion_date).format("YYYY-MM-DD")
        );
      })
    : [];

  return (
    <div>
      <Helmet>
        <title>Asset List</title>
      </Helmet>
      <Paper sx={{ width: "100%", height: "calc(90dvh - 100px)" }}>
        <DataGrid
          columns={columns}
          style={{
            backgroundColor: `${mode === "dark" ? "#101418" : "#ffffff"}`,
            color: `${mode === "dark" ? "#fff" : "#000"}`,
            height: "calc(90dvh - 100px)",
          }}
          sx={{
            boxShadow: 2,
            border: 1,
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-footerCell": {
              backgroundColor: "primary.main",
            },
            "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
              backgroundColor: mode === "light" ? "#fafafa" : "#1d1d1d",
              borderBottom: `1px solid ${
                mode === "light" ? "#f0f0f0" : "#303030"
              }`,
            },
            "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
              borderRight: `1px solid ${
                mode === "light" ? "#f0f0f0" : "#303030"
              }`,
            },
            "& .MuiDataGrid-cell": {
              color:
                mode === "light" ? "rgba(0,0,0,.85)" : "rgba(255,255,255,0.65)",
            },
          }}
          rows={rows}
          {...rows}
          slots={{ toolbar: GridToolbar, pagination: CustomPagination }}
          loading={rows.length === 0}
        />
      </Paper>
    </div>
  );
}
